<ng1-profile-diary [selectedPerson]="selectedPerson"></ng1-profile-diary>
